webpackJsonp([87192162464282],{

/***/ 125:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _panel = __webpack_require__(228);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Accordion = function (_React$Component) {
	    _inherits(Accordion, _React$Component);
	
	    function Accordion(props) {
	        _classCallCheck(this, Accordion);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            currentPanel: 1
	        };
	        return _this;
	    }
	
	    Accordion.prototype.componentDidMount = function componentDidMount() {
	        switch (this.props.route) {
	            case 'privatpatient':
	                this.setState({
	                    currentPanel: 1
	                });
	                break;
	            case 'schwangerschaft':
	                this.setState({
	                    currentPanel: 2
	                });
	                break;
	            case 'kontrastmittel':
	                this.setState({
	                    currentPanel: 3
	                });
	                break;
	            case 'stillen':
	                this.setState({
	                    currentPanel: 4
	                });
	                break;
	            case 'mammographie':
	                this.setState({
	                    currentPanel: 5
	                });
	                break;
	            case 'ergebnisse':
	                this.setState({
	                    currentPanel: 6
	                });
	                break;
	            default:
	                this.setState({
	                    currentPanel: 0
	                });
	        }
	    };
	
	    Accordion.prototype.updateCurrentPanel = function updateCurrentPanel(id) {
	        this.setState({
	            currentPanel: id
	        });
	    };
	
	    Accordion.prototype.render = function render() {
	        var _this2 = this;
	
	        var children = this.props.children;
	        var currentPanel = this.state.currentPanel;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'container-custom' },
	            _react2.default.createElement(
	                _panel2.default,
	                { active: currentPanel == 1 ? true : false },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'panel--title large', onClick: function onClick() {
	                            return _this2.updateCurrentPanel(1);
	                        } },
	                    'Wie erhalte ich einen Termin als Privatpatient?'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel--content' },
	                    'Privatpatienten erhalten au\xDFerhalb der Kassen\xF6ffnungszeiten unter der Telefonnummer 0664 4155619 Termine.'
	                )
	            ),
	            _react2.default.createElement(
	                _panel2.default,
	                { active: currentPanel == 2 ? true : false },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'panel--title large', onClick: function onClick() {
	                            return _this2.updateCurrentPanel(2);
	                        } },
	                    'Was gilt es bei einer Schwangerschaft zu beachten?'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel--content' },
	                    'Schwangere Frauen werden in unserem Institut nicht ger\xF6ntgt.',
	                    _react2.default.createElement('br', null),
	                    'MRT-Untersuchungen sind nur nach R\xFCcksprache mit der/dem/ zuweisenden \xC4rztin/Arzt und des Radiologen ab dem 2. Trimenon m\xF6glich.',
	                    _react2.default.createElement('br', null),
	                    'Ultraschalluntersuchungen k\xF6nnen immer durchgef\xFChrt werden.'
	                )
	            ),
	            _react2.default.createElement(
	                _panel2.default,
	                { active: currentPanel == 3 ? true : false },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'panel--title large', onClick: function onClick() {
	                            return _this2.updateCurrentPanel(3);
	                        } },
	                    'Was sind Kontrastmittel?'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel--content' },
	                    'Durch Kontrastmittel k\xF6nnen bestimmte Strukturen (Entz\xFCndungen, Tumore, Blutgef\xE4\xDFe etc.) besser beurteilt werden. Da MR-Kontrastmittel \xFCber die Nieren ausgeschieden wird, ben\xF6tigen wir Ihren aktuellen Nieren-Blutwert (Kreatininwert), bitte bringen Sie diesen zur Untersuchung mit.',
	                    _react2.default.createElement('br', null),
	                    'Die Fahrtauglichkeit wird nicht beeintr\xE4chtigt.'
	                )
	            ),
	            _react2.default.createElement(
	                _panel2.default,
	                { active: currentPanel == 4 ? true : false },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'panel--title large', onClick: function onClick() {
	                            return _this2.updateCurrentPanel(4);
	                        } },
	                    'Was ist, wenn ich stille?'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel--content' },
	                    'R\xF6ntgenstrahlen haben keine Auswirkungen auf das Stillen.',
	                    _react2.default.createElement('br', null),
	                    'Bitte teilen Sie uns vor einer Kontrastmittelgabe mit, dass Sie stillen.'
	                )
	            ),
	            _react2.default.createElement(
	                _panel2.default,
	                { active: currentPanel == 5 ? true : false },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'panel--title large', onClick: function onClick() {
	                            return _this2.updateCurrentPanel(5);
	                        } },
	                    'In welchen zeitlichen Abst\xE4nden kann ich eine Mammographie in Anspruch nehmen?'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel--content' },
	                    'F\xFCr eine Vorsorge-Mammographie bei Frauen zwischen 45 und 69 Jahren ist die E-card alle zwei Jahre automatisch freigeschaltet.',
	                    _react2.default.createElement('br', null),
	                    'Ausf\xFChrliche Informationen hierzu erhalten sie auf der Internetseite: ',
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'http://www.frueh-erkennen.at' },
	                        'www.frueh-erkennen.at'
	                    ),
	                    _react2.default.createElement('br', null),
	                    'Bei Beschwerden k\xF6nnen Sie jederzeit mit einer \xDCberweisung einen Termin bei uns vereinbaren.'
	                )
	            ),
	            _react2.default.createElement(
	                _panel2.default,
	                { active: currentPanel == 6 ? true : false },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'panel--title large', onClick: function onClick() {
	                            return _this2.updateCurrentPanel(6);
	                        } },
	                    'Wer teilt mir meine Untersuchungsergebnisse mit?'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel--content' },
	                    'Die Befundbesprechung erfolgt bei Ihrer/Ihrem \xFCberweisenden \xC4rztin/Arzt.'
	                )
	            )
	        );
	    };
	
	    return Accordion;
	}(_react2.default.Component);
	
	exports.default = Accordion;
	module.exports = exports['default'];

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(409);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Panel = function Panel(_ref) {
	    var children = _ref.children,
	        active = _ref.active;
	    return _react2.default.createElement(
	        'div',
	        { className: 'accordion--panel' + (active ? ' active' : '') },
	        children
	    );
	};
	
	exports.default = Panel;
	module.exports = exports['default'];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _page = __webpack_require__(5);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _accordion = __webpack_require__(227);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	__webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FaqPage = function (_React$Component) {
	  _inherits(FaqPage, _React$Component);
	
	  function FaqPage(props) {
	    _classCallCheck(this, FaqPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  FaqPage.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        location = _props.location;
	
	    var faqnumber = location.search.substr(1);
	    return _react2.default.createElement(
	      'main',
	      null,
	      _react2.default.createElement(_page2.default, { headline: 'H\xE4ufig gestellte Fragen' }),
	      _react2.default.createElement(_accordion2.default, { route: faqnumber })
	    );
	  };
	
	  return FaqPage;
	}(_react2.default.Component);
	
	exports.default = FaqPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-faq-js-3c35d14fdc47afcfcb0d.js